import React, { useState } from 'react';
const ReadMoreTruncateText = ({ text, limit }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) return null;

  const truncatedText = text.slice(0, limit);
  const shouldTruncate = text.length > limit;

  return (
    <div className="">
      <p className="ev-small-p-dark mb-1"> 
        {isExpanded ? text : truncatedText}
        {shouldTruncate && !isExpanded && ''}
        &nbsp;
        {shouldTruncate && (
          <button
            onClick={(e) => {
              e.stopPropagation();  // <-- Add this line
              setIsExpanded(!isExpanded);
            }}
            type="button"
            className="ev-btn-blue-outline-round ev-btn-xsmall ev-bold-reg" 
          >
            {isExpanded ? (
              <>
                Read less <i className="bi bi-chevron-up"></i>
              </>
            ) : (
              <>
                Read more <i className="bi bi-chevron-down"></i>
              </>
            )}
          </button>
        )}
      </p>
    </div>
  );
};

export default ReadMoreTruncateText;